import React, { useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, withRouter } from "react-router-dom";
import { useHistory } from "react-router";
import Covereditor from "../../Components/CoverEditor/coverEditor";
import Visualeditor from "../../Components/Visualeditor/Visualeditor";
import DeletePopup from "../../Components/DeletePopup/DeletePopup";
import Profeature from "../../Components/Profeature/Profeature";
import Deleteresume from "../../Components/Deleteresume/Deleteresume";
import Duplicateresume from "../../Components/Duplicateresume/Duplicateresume";
import Shareresume from "../../Components/Shareresume/Shareresume";
import { Helmet } from "react-helmet";
import { pageLayoutContext } from "../../Context/PageLayoutContext";
import {
  getCoverById,
  sampleCoverById,
} from "../../Store/Actions/CoverLetterActions";
import { userParticularGet } from "../../Store/Actions/UserActions";
import "./Editor.scss";
import { userTypeContext } from "../../Context/FreeOrProContext";
import { ExternalUserContext } from "../../Context/externalUserContext";
import Footer from "../../Components/Footer/Footer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import EditorNewHeader from "../../Components/Organisms/EditorHeader/EditorHeader";
import CoverNavbar from "../../Components/Organisms/CoverNavBar/CoverNavbar";
import SampleCoverContentModal from "../../Components/Modals/SampleCoverContentModal/SampleCoverContentModal";
import { resumeEditActions } from "../../Store/Actions/ResumeActions";
import { jsonEditorContext } from "../../Context/jsonEditorContext";
import { ResumePopupContext } from "../../Context/resumePopupContext";
import { COVER_CREATE_RESET } from "../../Store/Constants/CoverLetterConstants";
import CoverMobileEditor from "../CoverMobileEditor/coverEditor";
import { createCoverLetter } from "../../Store/Actions/CoverLetterActions";
import LoginPopup from "../../Components/Modals/LoginPopup/LoginPopup";
import SideCoverTemplate from "../../Components/SideCoverTemplate/SideCoverTemplate";
import { timeDifference } from "../../Utils/Common";
import EditorSpinner from "../../Utils/EditorSaveSpinner";
import ChangeResumeOrder from "../../hooks/editor/changeResumeOrder";
import OutsideClickHandler from "react-outside-click-handler";
import CoverUseForm from "../../hooks/editor/coverUseForm";
import "./Editorheader.scss";
import { covertemplateGetActions } from "../../Store/Actions/TemplateActions";
import PickCovertemplate from "../../Components/PickCoverLetter/Picktemplate";
import SideCoverNavbar from "../../Components/SideCoverNavbar/SideCoverNavbar";

function Editor(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const url = window.location.search;
  const path = window.location.pathname;
  const shareUrl = path.split("/");

  const query = new URLSearchParams(window.location.search);
  const job = query.get("job");
  const exp = query.get("exp");
  const [coverData, setCoverData] = useState("");
  const [actionToggle, setActionToggle] = useState(false);
  const [showPremiumIndicator, setShowPremiumIndicator] = useState(false);
  const [leaveUrl, setLeaveUrl] = useState("");
  const [showClosePopup, setShowClosePopup] = useState(false);

  const [showLogin, setShowLogin] = useState(false);
  const { coverLetter } = useSelector((state) => state.coverParticular);
  const userData = useSelector((state) => state.particularuser.user);

  const loadUserData = useSelector((state) => state.userData.userInfo);
  const coverEditorData = useSelector((state) => state.coverData);
  const create = useSelector((state) => state.coverCreate);
  const savedTime = useSelector((state) => state.coverLastUpdatedAt);
  const loading = useSelector((state) => state.loading);
  const resumeLoading = useSelector((state) => state.resumeLoading);

  const {
    preview,
    setPreview,
    sideBasic,
    setSideBasic,
    suggestionSection,
    setSuggestionSection,
    setSuggestionIndex,
  } = useContext(ResumePopupContext);

  const {
    coverJson,
    isCoverJson,
    setIsCoverJson,
    isCoverSample,
    setIsCoverSample,
  } = useContext(jsonEditorContext);

  const {
    resumeFields,
    setResumeFields,
    resumeHandler,
    sizeHandler,
    fontHandler,
    colorHandler,
    backgroundUpdate,
    multiColorHandler,
    handleEditorChange,
    resumeUpdate,
    changeHeaderSettings,
    handleWebsiteDelete,
    removeProfeatures,
  } = CoverUseForm(isCoverJson, coverJson, props.sample);

  useEffect(() => {
    if (coverLetter && coverLetter != "") {
      if (path.includes("create")) {
        if (loadUserData && loadUserData.token) {
          document.cookie = `sample=false; path=/; secure; domain=qwikresume.com; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
          document.cookie = `coverSample=false; path=/; secure; domain=qwikresume.com; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
          localStorage.removeItem("onboardingTemplate");
          //   let data = {};
          var data = { ...coverEditorData };
          data.from = {
            ...data.from,
            name: userData && userData.first_name ? userData.first_name : "",
            email: userData && userData.email ? userData.email : "",
            photo:
              userData && userData.profile_image ? userData.profile_image : "",
            jobTitle: userData && userData.job_title ? userData.job_title : "",
          };
          data.title =
            coverLetter && coverLetter.job_title
              ? coverLetter && coverLetter.job_title
              : "Untitled";
          data.thumb = "";
          data.type = "cover_letter";
          data.content = JSON.stringify(data);
          data.isLetter = 0;
          data.completed = false;
          data.template_id = coverLetter && coverLetter.template_id;
          dispatch(createCoverLetter(data));
        } else {
          history.push("/");
        }
      }
    }
  }, [coverLetter]);

  useEffect(() => {
    if (
      resumeFields &&
      resumeFields.lockedFeatures &&
      resumeFields.lockedFeatures.length > 0
    ) {
      setShowPremiumIndicator(true);
    } else if (
      resumeFields &&
      resumeFields.lockedFeatures &&
      resumeFields.lockedFeatures.length == 0
    ) {
      setShowPremiumIndicator(false);
    }
  }, [resumeFields]);

  const handlePayment = () => {
    history.push("/pricingplansnew");
  };

  useEffect(() => {
    if (path.includes("create")) {
      if (preview) {
      } else {
        if (props && props.sample) {
        } else {
          dispatch(sampleCoverById(id));
        }
      }
    } else {
      if (id && id != "") {
        if (props && props.sample) {
        } else {
          dispatch(getCoverById(id, shareUrl[1]));
        }
      }
    }
    // dispatch(templateGetActions(false))
  }, [id]);

  useEffect(() => {
    if (!props.previewModal && !props.sample) {
      dispatch(covertemplateGetActions(false));
    }
  }, []);

  useEffect(() => {
    if (
      create &&
      create.data &&
      create.data.type &&
      create.data.type === "cover_letter"
    ) {
      history.push(`/coverletter/${create.data.id}`);
      dispatch({ type: COVER_CREATE_RESET });
    }
  }, [create]);

  const {
    resumeCount,
    showProPopup,
    setShowProPopup,
    showProPopupMessage,
    setShowProPopupMessage,
    popupType,
    setPopupType,
    userType,
    setUserType,
  } = useContext(userTypeContext);
  const [Shareurl, setShareURL] = useState();
  const [time, setTime] = useState("");

  const [modalShow, setModalShow] = useState(false);
  const onHide = () => setModalShow(false);
  const openmodal = () => setModalShow(true);
  const [deletePopup, setDeletePopup] = useState(false);
  const [editorEventKey, setEditorEventKey] = useState("second");
  const [showPreview, setShowPreview] = useState(false);
  const [showSample, setShowSample] = useState(false);
  const [switchEditor, setSwitchEditor] = useState(true);
  const [showMediumDesignbar, setShowMediumDesignbar] = useState(false);

  const [rand, setRand] = useState(0);

  const [imgChange, setImgChange] = useState(false);

  const backgroundChange = () => {
    setImgChange(true);
  };

  const hideImgModal = () => {
    setImgChange(false);
  };
  const handleHide = () => {
    setShowLogin(false);
  };
  const showDeletePopup = () => {
    setDeletePopup(true);
  };
  const hidePopup = () => {
    setDeletePopup(false);
  };

  //Duplicatereume popup
  const [duplicateShow, duplicatesetModalShow] = useState(false);
  const duplicateHide = () => duplicatesetModalShow(false);
  const duplicatemodal = () => duplicatesetModalShow(true);
  //Sharereume popup
  const [shareShow, sharesetModalShow] = useState(false);
  const shareHide = () => sharesetModalShow(false);

  const sharemodal = () => {
    if (isLogin && isLogin) {
      if (userType && userType == "free") {
        setShowProPopup(true);
        setShowProPopupMessage("Please upgrade to Pro");
      } else {
        sharesetModalShow(true);
      }
    } else {
      setShowLogin(true);
    }
  };
  //   useEffect(() => {
  //     dispatch(userParticularGet());
  //   }, []);

  const toggleSidebar = () => {
    setActionToggle(!actionToggle);
  };

  useEffect(() => {
    const copyURL = window.location.href;
    setShareURL(copyURL);
  }, [url]);

  /**
   * @todo is there any better way cover letter we can set
   */

  //Template Popup

  const { isLogin, setIsLogin } = useContext(ExternalUserContext);
  const { isMobile, setIsMobile } = useContext(pageLayoutContext);

  const hidePreview = () => {
    setShowPreview(false);
  };
  const hideSample = () => {
    setShowSample(false);
    if (path.includes("create")) {
      history.push(`/create-cover/sample/${id}`);
    } else if (path.includes("coverletter")) {
      history.push(`/coverletter/${id}`);
    } else {
      history.push(`/coverletter/${id}`);
    }
  };

  useEffect(() => {
    if (job != "" && job != null) {
      setShowSample(true);
    }
  }, [job]);

  const hideShowProPopup = () => {
    setShowProPopup(false);
    duplicatesetModalShow(false);
  };

  const sizeHandle = (checked, type) => {
    let data = { ...coverEditorData };
    const body = {
      title: coverLetter && coverLetter.title,
      body: "Body",
      content: JSON.stringify(data),
      completed: false,
      isLetter: checked ? 1 : 0,
      type: type,
      template_id: coverLetter && coverLetter.template_id,
    };
    dispatch(resumeEditActions(id, body));
  };

  const customizationData = useSelector(
    (state) => state.coverData.customization
  );

  //   const layoutData = useSelector((state) => state.editorData.layout);

  const customStyle = isCoverJson
    ? coverJson && coverJson.customization
    : customizationData;

  useEffect(() => {
    if (path && path.includes("coverpreview")) {
      document.getElementById("root").style.backgroundColor =
        customStyle && customStyle.colors && customStyle.colors.bgColor;
      document.body.style.backgroundColor =
        customStyle && customStyle.colors && customStyle.colors.bgColor;
    }
  }, [customStyle]);

  useEffect(() => {
    setIsCoverJson(false);
    setIsCoverSample(false);
    setPreview(false);
  }, []);

  useEffect(() => {
    if (props.preview && !props.previewModal) {
      setIsCoverJson(true);
    }
    if (props && props.sample && !props.previewModal) {
      setIsCoverJson(true);
      setIsCoverSample(true);
    }
    // if ((props && props.previewModal) || (props && props.preview)) {
    //   setVisualEditorFocus(false);
    // }
  }, [props]);

  const [isSideBar, setIsSideBar] = useState(false);
  const [isSideBasic, setIsSideBasic] = useState(false);
  const [selectedSection, setSelectedSection] = useState("");

  const ShowTemplate = () => {
    setIsSideBar(!isSideBar);
  };

  const hideTemplate = () => {
    setIsSideBar(false);
  };

  const changeEditor = () => {
    setSwitchEditor(!switchEditor);
  };

  const enableMainBasic = (section) => {
    setSelectedSection(section);
    if (selectedSection == section) {
      setPreview(!preview);
      setIsSideBasic(!isSideBasic);
      setSideBasic(false);
      setSuggestionSection("");
      setSuggestionIndex("");
      setRand(0);
    } else {
      setSuggestionIndex(0);
      setIsSideBasic(true);
    }
  };
  const hideSideBasic = () => {
    setPreview(false);
    setIsSideBasic(false);
  };
  useEffect(() => {
    var interval = "";
    if (savedTime && savedTime.date) {
      let updated = timeDifference(savedTime.date);
      setTime(updated);

      interval = setInterval(() => {
        let updated = timeDifference(savedTime.date);
        setTime(updated);
      }, 10000);
    }
    return () => {
      clearInterval(interval);
    };
  }, [savedTime]);

  const showSamplePopup = () => {
    setShowSample(true);
  };

  useEffect(() => {
    if (sideBasic && sideBasic) {
      setIsSideBasic(true);
    }
  }, [sideBasic]);

  const css = `@media print {
	body {
	  background-color: ${
      customStyle && customStyle.colors && customStyle.colors.bgColor
    } !important;
	}
  }`;

  //   const DarkTheme = `
  //   .preview-resume-modal .coverEditor{
  // 	width:940px !important;
  //   }
  //   .coverEditor {
  // 	width: 100% !important;
  // 	max-width:940px;
  //   }
  //   `;
  const handleMediumDesignbar = () => {
    setShowMediumDesignbar(!showMediumDesignbar);
  };
  return (
    <>
      {path && path.includes("coverletter") && (
        <Helmet>
          <meta
            name="description"
            content="Qwikresume.com helps you create compelling resumes with ease using Resume Samples created by Professionals."
          />
          <meta
            name="keywords"
            content="resume, cover letter, online resume editor, cv, resume builder, create a resume, create cv, resume templates, cv templates"
          />
          <meta name="robots" content="noindex, nofollow" />
          <meta
            itemprop="name"
            content="Create your Resume with Ease - Qwikresume"
          />
          <meta
            itemprop="description"
            content="Qwikresume.com helps you create compelling resumes with ease using Resume Samples created by Professionals."
          />
          <title>Cover Letter Editor - Qwikresume.com</title>
        </Helmet>
      )}
      {path && path.includes("qrcover") && <style>{css}</style>}
      {/* {path && path.includes("coverletter") && !props.previewModal && (
        <style>{DarkTheme}</style>
      )} */}
      {(path && path.includes("coverpreview")) ||
      (path && path.includes("qrcover")) ? (
        <>
          <div style={{ pointerEvents: "none" }}>
            {coverLetter && (
              <div className={`coverEditor`}>
                <Covereditor
                  resumeFields={resumeFields}
                  setResumeFields={setResumeFields}
                  handleEditorChange={handleEditorChange}
                  resumeUpdate={resumeUpdate}
                  resumeHandler={resumeHandler}
                  previewModal={props.previewModal}
                />
              </div>
            )}
          </div>
        </>
      ) : props && props.sample ? (
        <>
          <div className={`coverEditor`}>
            <Covereditor
              resumeFields={resumeFields}
              setResumeFields={setResumeFields}
              handleEditorChange={handleEditorChange}
              resumeUpdate={resumeUpdate}
              resumeHandler={resumeHandler}
              previewModal={props.previewModal}
            />
          </div>
        </>
      ) : props && props.preview ? (
        <>
          {coverLetter && (
            <div className={`coverEditor`}>
              <Covereditor
                resumeFields={resumeFields}
                setResumeFields={setResumeFields}
                handleEditorChange={handleEditorChange}
                resumeUpdate={resumeUpdate}
                resumeHandler={resumeHandler}
                previewModal={props.previewModal}
              />
            </div>
          )}
        </>
      ) : (
        <>
          <div className="app-wrapper">
            <ToastContainer
              toastStyle={{
                width: "203px",
                fontSize: "12px",
                minHeight: "30px",
                float: "right",
                marginTop: "15%",
              }}
              position="top-right"
              hideProgressBar
              autoClose={2000}
              draggable
            />

            {coverLetter && (
              <React.Fragment>
                <Profeature
                  popupType={popupType}
                  show={showProPopup}
                  onHide={hideShowProPopup}
                  showProPopupMessage={showProPopupMessage}
                />
                <LoginPopup show={showLogin} hide={handleHide} />
                <PickCovertemplate
                  isSideBar={isSideBar}
                  hideTemplate={hideTemplate}
                  resumeFields={resumeFields}
                  setResumeFields={setResumeFields}
                />
                {/* <OutsideClickHandler
                  onOutsideClick={(e, value) => {
                    const parentWithClass = e.target.closest(
                      ".resume-page-wrapper"
                    );
                    const anotherParentWithClass = e.target.closest(
                      ".designbar-template"
                    );
                    if (
                      isSideBar &&
                      parentWithClass == null &&
                      anotherParentWithClass == null
                    ) {
                      setIsSideBar(false);
                    } else if (isSideBar && anotherParentWithClass != "") {
                      setIsSideBar(true);
                    } else {
                      // setOutSideClick(false);
                    }
                  }}
                >
                  <SideCoverTemplate
                    isSideBar={isSideBar}
                    hideTemplate={hideTemplate}
                    resumeFields={resumeFields}
                    setResumeFields={setResumeFields}
                  />
                </OutsideClickHandler> */}
                <OutsideClickHandler
                  onOutsideClick={(e, value) => {
                    const parentWithClass = e.target.closest(
                      ".medium-parent-desingerbar-wrapper"
                    );
                    const anotherParentWithClass =
                      e.target.closest(".sidebarCover");
                    const anotherParentWithHeadClass = e.target.closest(
                      ".editor-header-ellipsis"
                    );
                    if (
                      showMediumDesignbar &&
                      parentWithClass == null &&
                      anotherParentWithClass == null &&
                      anotherParentWithHeadClass == null
                    ) {
                      setShowMediumDesignbar(false);
                    } else if (showMediumDesignbar && parentWithClass != "") {
                      setShowMediumDesignbar(true);
                    }
                  }}
                >
                  <SideCoverNavbar
                    showMediumDesignbar={showMediumDesignbar}
                    setShowMediumDesignbar={setShowMediumDesignbar}
                  >
                    <CoverNavbar
                      cover={"cover"}
                      setEditorEventKey={setEditorEventKey}
                      editorEventKey={editorEventKey}
                      duplicateShow={duplicatemodal}
                      shareShow={sharemodal}
                      setActionToggle={toggleSidebar}
                      showDeletePopup={showDeletePopup}
                      showSamplePopup={showSamplePopup}
                      id={id}
                      showPreview={showPreview}
                      hidePreview={hidePreview}
                      resumeFields={resumeFields}
                      setResumeFields={setResumeFields}
                      sizeHandle={sizeHandle}
                      sizeHandler={sizeHandler}
                      fontHandler={fontHandler}
                      colorHandler={colorHandler}
                      backgroundUpdate={backgroundUpdate}
                      multiColorHandler={multiColorHandler}
                      resumeUpdate={resumeUpdate}
                      ShowTemplate={ShowTemplate}
                      setIsCoverSample={setIsCoverSample}
                    />
                  </SideCoverNavbar>
                </OutsideClickHandler>
                <Deleteresume
                  deleteId={id}
                  deleteResume={deletePopup}
                  cover={"cover"}
                  hideResume={hidePopup}
                  page="editor"
                />
                <Duplicateresume
                  show={duplicateShow}
                  cover={"cover"}
                  duplicateHide={duplicateHide}
                  resume={coverLetter}
                />
                <Shareresume
                  show={shareShow}
                  cover={"cover"}
                  shareHide={shareHide}
                  Shareurl={Shareurl}
                  resumeId={coverLetter && coverLetter.random_code}
                />
                <SampleCoverContentModal
                  showSample={showSample}
                  job={job}
                  hideSample={hideSample}
                  resumeFields={resumeFields}
                  setResumeFields={setResumeFields}
                />

                {/* {showTemplate && <Picktemplate />} */}
                <DeletePopup />
                <div className="editor-header-div">
                  <EditorNewHeader
                    handleMediumDesignbar={handleMediumDesignbar}
                    setLeaveUrl={setLeaveUrl}
                    setShowClosePopup={setShowClosePopup}
                    path={path}
                    resumeUpdateToServer={""}
                  />
                  <hr style={{ margin: "0", padding: "0", color: "#929aab" }} />
                </div>

                {/* <div className="add-cover-section-div ">
                  <div className="row m-0">
                    <div className="col-8 col-md-6"></div>
                    <div className="col-4 col-md-6">
                      <div className="d-flex" style={{ float: "right" }}>
                        <div>
                          {isLogin && isLogin ? (
                            <EditorSpinner />
                          ) : (
                            <span
                              className="saveyourwork-info"
                              onClick={() => setShowLogin(true)}
                            >
                              {" "}
                              <i
                                class="fa fa-info-circle mr-2"
                                aria-hidden="true"
                              ></i>{" "}
                              Sign up to save your work
                            </span>
                          )}
                        </div>
                        <div className="d-none d-md-block">
                          {isLogin && isLogin && time && time != "" && (
                            <p
                              className="pl-4  m-0"
                              style={{ paddingTop: "6px" }}
                            >
                              Saved {time} ago
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}

                {isMobile && isMobile ? (
                  <>
                    <div className=" d-none d-sm-none d-md-block d-lg-none d-xl-none">
                      <div
                        className="medium-parent-desingerbar"
                        onClick={handleMediumDesignbar}
                      >
                        <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                      </div>
                    </div>
                    {/* {showMediumDesignbar && (
                      <div
                        style={{ backgroundColor: "#ffffff" }}
                        className="medium-parent-desingerbar-wrapper"
                      >
                        {" "}
                        <CoverNavbar
                          cover={"cover"}
                          setEditorEventKey={setEditorEventKey}
                          editorEventKey={editorEventKey}
                          duplicateShow={duplicatemodal}
                          shareShow={sharemodal}
                          setActionToggle={toggleSidebar}
                          showDeletePopup={showDeletePopup}
                          showSamplePopup={showSamplePopup}
                          id={id}
                          showPreview={showPreview}
                          hidePreview={hidePreview}
                          resumeFields={resumeFields}
                          setResumeFields={setResumeFields}
                          sizeHandle={sizeHandle}
                          sizeHandler={sizeHandler}
                          fontHandler={fontHandler}
                          colorHandler={colorHandler}
                          backgroundUpdate={backgroundUpdate}
                          multiColorHandler={multiColorHandler}
                          resumeUpdate={resumeUpdate}
                          ShowTemplate={ShowTemplate}
                          setIsCoverSample={setIsCoverSample}
                        />
                      </div>
                    )} */}
                    <div className="" style={{ paddingTop: "70px" }}>
                      <CoverMobileEditor
                        resumeFields={resumeFields}
                        setResumeFields={setResumeFields}
                        handleEditorChange={handleEditorChange}
                        resumeUpdate={resumeUpdate}
                        resumeHandler={resumeHandler}
                        changeHeaderSettings={changeHeaderSettings}
                        handleWebsiteDelete={handleWebsiteDelete}
                        previewModal={props.previewModal}
                      />
                    </div>

                    {showPremiumIndicator &&
                      showPremiumIndicator &&
                      userType &&
                      userType != "pro" && (
                        <>
                          <div className="Premium-indicator-popup">
                            <div className="row">
                              <div className="col-md-8 col-12 col-sm-12 align-self-center">
                                <p className="pro-indicator-text">
                                  This Resume is using Pro features.You need to
                                  remove them or upgrade to download.
                                </p>
                              </div>
                              <div className="col-md-4 col-12 col-sm-12">
                                <div className="d-flex">
                                  {path && path.includes("create") ? (
                                    <>
                                      <div>
                                        <button
                                          className="btn removepro-upgrade"
                                          onClick={() => setShowLogin(true)}
                                        >
                                          Sign In
                                        </button>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <div>
                                        <button
                                          className="btn removepro-upgrade"
                                          onClick={() => handlePayment()}
                                        >
                                          Upgrade
                                        </button>
                                      </div>
                                    </>
                                  )}
                                  <div
                                    className="ml-2 editor-remove-pro"
                                    onClick={() => removeProfeatures()}
                                  >
                                    Remove pro features
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                  </>
                ) : (
                  <>
                    <div className="d-flex justify-content-center">
                      <div className="d-none d-sm-none d-md-block d-lg-none d-xl-none">
                        <div
                          className="medium-parent-desingerbar"
                          onClick={handleMediumDesignbar}
                        >
                          <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                        </div>
                      </div>
                      {/* {showMediumDesignbar && (
                        <OutsideClickHandler
                          onOutsideClick={(e, value) => {
                            const parentWithClass = e.target.closest(
                              ".medium-parent-desingerbar-wrapper"
                            );
                            const anotherParentWithClass = e.target.closest(
                              ".medium-parent-desingerbar"
                            );
                            const anotherParentWithHeadClass = e.target.closest(
                              ".editor-header-ellipsis"
                            );
                            if (
                              showMediumDesignbar &&
                              parentWithClass == null &&
                              anotherParentWithClass == null &&
                              anotherParentWithHeadClass == null
                            ) {
                              setShowMediumDesignbar(false);
                            } else if (
                              showMediumDesignbar &&
                              parentWithClass != ""
                            ) {
                              setShowMediumDesignbar(true);
                            }
                          }}
                        >
                          <div
                            style={{ backgroundColor: "#ffffff" }}
                            className="medium-parent-desingerbar-wrapper"
                          >
                            {" "}
                            <CoverNavbar
                              cover={"cover"}
                              setEditorEventKey={setEditorEventKey}
                              editorEventKey={editorEventKey}
                              duplicateShow={duplicatemodal}
                              shareShow={sharemodal}
                              setActionToggle={toggleSidebar}
                              showDeletePopup={showDeletePopup}
                              showSamplePopup={showSamplePopup}
                              id={id}
                              showPreview={showPreview}
                              hidePreview={hidePreview}
                              resumeFields={resumeFields}
                              setResumeFields={setResumeFields}
                              sizeHandle={sizeHandle}
                              sizeHandler={sizeHandler}
                              fontHandler={fontHandler}
                              colorHandler={colorHandler}
                              backgroundUpdate={backgroundUpdate}
                              multiColorHandler={multiColorHandler}
                              resumeUpdate={resumeUpdate}
                              ShowTemplate={ShowTemplate}
                              setIsCoverSample={setIsCoverSample}
                            />
                          </div>
                        </OutsideClickHandler>
                      )} */}
                      <div
                        className="d-none d-sm-none d-md-none d-lg-block"
                        style={{ width: "300px", marginTop: "52px" }}
                      >
                        <CoverNavbar
                          cover={"cover"}
                          setEditorEventKey={setEditorEventKey}
                          editorEventKey={editorEventKey}
                          duplicateShow={duplicatemodal}
                          shareShow={sharemodal}
                          setActionToggle={toggleSidebar}
                          showDeletePopup={showDeletePopup}
                          showSamplePopup={showSamplePopup}
                          id={id}
                          showPreview={showPreview}
                          hidePreview={hidePreview}
                          resumeFields={resumeFields}
                          setResumeFields={setResumeFields}
                          sizeHandle={sizeHandle}
                          sizeHandler={sizeHandler}
                          fontHandler={fontHandler}
                          colorHandler={colorHandler}
                          backgroundUpdate={backgroundUpdate}
                          multiColorHandler={multiColorHandler}
                          resumeUpdate={resumeUpdate}
                          ShowTemplate={ShowTemplate}
                          setIsCoverSample={setIsCoverSample}
                        />
                      </div>
                      <div>
                        <div className={`coverEditor cover-editor-wrapper`}>
                          <Covereditor
                            resumeFields={resumeFields}
                            setResumeFields={setResumeFields}
                            handleEditorChange={handleEditorChange}
                            resumeUpdate={resumeUpdate}
                            resumeHandler={resumeHandler}
                            changeHeaderSettings={changeHeaderSettings}
                            handleWebsiteDelete={handleWebsiteDelete}
                            previewModal={props.previewModal}
                          />
                          {showPremiumIndicator &&
                            showPremiumIndicator &&
                            userType &&
                            userType != "pro" && (
                              <>
                                <div className="Premium-indicator-popup">
                                  <div className="row">
                                    <div className="col-md-8 col-12 col-sm-12 align-self-center">
                                      <p className="pro-indicator-text">
                                        This Resume is using Pro features.You
                                        need to remove them or upgrade to
                                        download.
                                      </p>
                                    </div>
                                    <div className="col-md-4 col-12 col-sm-12">
                                      <div className="d-flex">
                                        {path && path.includes("create") ? (
                                          <>
                                            <div>
                                              <button
                                                className="btn removepro-upgrade"
                                                onClick={() =>
                                                  setShowLogin(true)
                                                }
                                              >
                                                Sign In
                                              </button>
                                            </div>
                                          </>
                                        ) : (
                                          <>
                                            <div>
                                              <button
                                                className="btn removepro-upgrade"
                                                onClick={() => handlePayment()}
                                              >
                                                Upgrade
                                              </button>
                                            </div>
                                          </>
                                        )}
                                        <div
                                          className="ml-2 editor-remove-pro"
                                          onClick={() => removeProfeatures()}
                                        >
                                          Remove pro features
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </React.Fragment>
            )}
          </div>
          <Footer />
        </>
      )}
    </>
  );
}

export default Editor;
